import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PermissionsetsLayoutComponent } from './overview/layout/permissionsets-layout.component';
import { EntityPermissionGuard, AskToDeactivateGuard } from '@kpd/framework-ngx';
import { PermissionsetDetailsComponent } from './detail/permissionset-details.component';
import { EntityResolverTypes } from '../app.entity.resolvers';
import { titleFunction } from 'app/app-routing.module';

const permissionsetsRoutes: Routes = [
  {
    path: 'permissionsets',
    component: PermissionsetsLayoutComponent,
    data: {
      routeName: 'permissionsets',
      routePermissionPrefix: 'Permissionset',
      breadCrumbData: { titleFunc: titleFunction('Permission sets') },
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
  },
  {
    path: 'permissionsets/details/application/:applicationId/permissionset/:type/:permissionSetId',
    component: PermissionsetDetailsComponent,
    data: {
      routeName: 'permissionsetDetail',
      routeParentName: 'permissionsets',
      routePermissionPrefix: 'Permissionset',
      routePermissionPrefixTabs: { permissionSets: 'Permissionset_Permissions' },
      routePermissionId: 'permissionSetId',
      breadCrumbData: {
        titleResolverType: EntityResolverTypes.permissionSet,
        titleEntityIdKeys: ['permissionSetId', 'applicationId', 'type'],
      },
      pageTitlePrefixFunc: titleFunction('Permission set'),
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'permissionsets/details/application/:applicationId/permissionset/:permissionSetId',
    component: PermissionsetDetailsComponent,
    data: {
      routeName: 'permissionsetDetail',
      routeParentName: 'permissionsets',
      routePermissionPrefix: 'Permissionset',
      routePermissionPrefixTabs: { permissionSets: 'Permissionset_Permissions' },
      routePermissionId: 'permissionSetId',
      breadCrumbData: {
        titleResolverType: EntityResolverTypes.permissionSet,
        titleEntityIdKeys: ['permissionSetId', 'applicationId'],
      },
      pageTitlePrefixFunc: titleFunction('Permission set'),
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(permissionsetsRoutes)],
  exports: [RouterModule],
})
export class PermissionsetsRoutingModule {}
